import Home from './Home'

export default Home
// eslint-disable-next-line import/export
export * from './Home'
